/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-null/no-null */
import { Autocomplete, Chip, Input } from '@mui/material';
import { useState, forwardRef } from 'react';

import { SearchBoxMenuOption, SearchBoxAutocompleteValue } from './search-box-types';
interface SearchBoxAutocompleteLabelSegmentProps {
    option: SearchBoxMenuOption;
    onEdit: (index: number, newValue?: SearchBoxAutocompleteValue, selectedOption?: SearchBoxMenuOption) => void;
    index: number;
    className: string;
    options: SearchBoxMenuOption[];
}

export const SearchBoxAutocompleteLabelSegment = forwardRef<HTMLDivElement, SearchBoxAutocompleteLabelSegmentProps>(
    ({ option, onEdit, index, className, options }, ref) => {
        const [focused, setFocused] = useState(false);

        return focused ? (
            <Autocomplete
                onKeyDown={(event) => {
                    if ('ArrowDown' === event.key || 'ArrowUp' === event.key) {
                        event.stopPropagation();
                    }
                }}
                autoSelect
                blurOnSelect
                options={options}
                renderOption={(props, autocompleteOption) => {
                    if (autocompleteOption.renderOption) {
                        return autocompleteOption.renderOption(props, autocompleteOption);
                    }

                    return <li {...props}>{autocompleteOption.menuLabel}</li>;
                }}
                getOptionLabel={(autocompleteOption) => {
                    return autocompleteOption.inputLabel;
                }}
                value={option}
                disableClearable
                openOnFocus
                onChange={(event, value) => {
                    onEdit(index, { optionName: value.name, optionRelation: 'eq' }, value);
                }}
                onClose={() => {
                    setFocused(false);
                }}
                // eslint-disable-next-line @typescript-eslint/naming-convention
                renderInput={({ InputProps, ...params }) => {
                    return (
                        <Input
                            {...params}
                            {...InputProps}
                            sx={{ width: 'auto' }}
                            inputProps={{
                                ...params.inputProps,
                                sx: { opacity: '1 !important', width: 'unset !important' },
                            }}
                            onKeyDown={(event) => {
                                if (
                                    ('ArrowLeft' === event.key && 0 === event.currentTarget.selectionStart) ||
                                    ('ArrowRight' === event.key &&
                                        event.currentTarget.value.length === event.currentTarget.selectionEnd) ||
                                    'ArrowDown' === event.key ||
                                    'ArrowUp' === event.key ||
                                    'Enter' === event.key ||
                                    'Tab' === event.key
                                ) {
                                    /* empty */
                                } else {
                                    event.stopPropagation();
                                }
                            }}
                            autoFocus
                        />
                    );
                }}
            />
        ) : (
            <Chip
                {...{ 'data-tag-index': index }}
                ref={ref}
                tabIndex={-1}
                className={className}
                label={option.inputLabel}
                size='medium'
                sx={{ borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
                onFocus={() => {
                    setFocused(true);
                }}
                onClick={() => {
                    setFocused(true);
                }}
            />
        );
    },
);
